(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-native"));
	else if(typeof define === 'function' && define.amd)
		define("ReactSpatialNavigation", ["react", "react-native"], factory);
	else if(typeof exports === 'object')
		exports["ReactSpatialNavigation"] = factory(require("react"), require("react-native"));
	else
		root["ReactSpatialNavigation"] = factory(root["react"], root["react-native"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__1389__) => {
return 